/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

import {
  SETTINGS_FETCH_WORKING_HOUR_REQUEST,
  SETTINGS_FETCH_WORKING_HOUR_REQUEST_SUCCESS,
  SETTINGS_FETCH_WORKING_HOUR_REQUEST_FAILURE,
  SETTINGS_UPSERT_WORKING_HOUR_REQUEST,
  SETTINGS_UPSERT_WORKING_HOUR_REQUEST_SUCCESS,
  SETTINGS_UPSERT_WORKING_HOUR_REQUEST_FAILURE,
  WORKING_HOUR_CLEAN_REQUEST,
} from './types';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  workingHourPayload: [],
  workingHourLoading: false,
  workingHourErrors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const workingHourReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case SETTINGS_FETCH_WORKING_HOUR_REQUEST:
      return Object.assign({}, state, {
        workingHourLoading: true,
      });

    case SETTINGS_FETCH_WORKING_HOUR_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        workingHourLoading: false,
        workingHourPayload: action.data,
        workingHourErrors: {},
      });

    case SETTINGS_FETCH_WORKING_HOUR_REQUEST_FAILURE:
      return Object.assign({}, state, {
        workingHourLoading: false,
        workingHourErrors: action.error,
      });
    case SETTINGS_UPSERT_WORKING_HOUR_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SETTINGS_UPSERT_WORKING_HOUR_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case SETTINGS_UPSERT_WORKING_HOUR_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case WORKING_HOUR_CLEAN_REQUEST:
      return Object.assign({}, state, {
        loading: false,
        errors: {},
        workingHourLoading: false,
        workingHourErrors: {},
      });

    default:
      return state;
  }
};

export default workingHourReducer;
